import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=68c5b68c&"
import script from "./InventoryManagement.vue?vue&type=script&lang=ts&"
export * from "./InventoryManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports